// Module
var code = "<div class=\"callout-message bg-color--jabra-yellow\" ng-if=\"$ctrl.canShow\" ng-bind-html=\"$ctrl.message\"> </div>";
// Exports
module.exports = code;